module.exports = __webpack_public_path__ + "static/img/5.dabd787.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/3/zh/5.png
// module id = v2da
// module chunks = 0